<template>
  <div>
    <div class="combo_box">
      <v-autocomplete dense outlined
        id="farm"
        ref="farm"
        class="farm"
        v-model="farm"
        prepend-inner-icon="mdi-home-circle"
        :items="farmItems"
        :menu-props="{ top: false, offsetY: true }"
        no-data-text="자료(권한)이 없습니다."
        item-text="name"
        return-object
        hide-details
        @focus="comboFarms()"
      >
      </v-autocomplete>

      <button
        v-show="$route.path !== '/trace/ship' && $route.path !== '/trace/grow' && $route.path !== '/esg/esgMonitor'  && $route.path !== '/watt' && $route.path !== '/package/RawData' "
        class="refresh_btn mt-2" 
        @click="fromFarm()">
        <v-icon color="white">
          mdi-refresh
        </v-icon>
      </button>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import VueCookies from "vue-cookies";
import dateUtil from "@/utils/custom/dateProperty.js";

export default {
  name: 'FarmCombobox',

  data(){
    return{
      farm : {},
      farmItems : [],
    }
  },
  watch: {
    farm: {
      handler() {
        this.fromFarm();
      },
      deep: true
    }
  },
  async created() {
    await this.comboFarms(); 

    let cookie_info = VueCookies.get("farm_info");

    let paramInfo = JSON.parse(sessionStorage.getItem("paramInfo"));
    if (paramInfo) {
      cookie_info = paramInfo;
      sessionStorage.removeItem("paramInfo");
    }

    if (cookie_info && cookie_info.farm) {
      this.company = cookie_info.company || {};

      const selectedFarm = this.farmItems.find(farmItem => farmItem.code === cookie_info.farm.code);
      if (selectedFarm) {
        this.farm = selectedFarm;
      } else {
        this.farm = this.farmItems[0] || {}; 
      }
    } else if (this.farmItems.length > 0) {
      this.farm = this.farmItems[0];
      this.company = { code: this.farm.company_cd, name: this.farm.company_name };
    }

    this.fromFarm();
  },

  methods:{
    async comboFarms() {
      await Apis.comboFarms({
        company_cd:  "",
        new_version : true,
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
        },(res) => {  
          if (res.result) {
            this.farmItems = [];

            for (let i in res.data) {
              const farmData = res.data[i].farm;
              // console.log(farmData)

              if (this.$route.path === "/trace/milk") {
                if (farmData.biz !== "CF05" && farmData.biz !== "CF06") {
                  continue; 
                }
              // }
              }else if(this.$route.path === "/watt" || this.$route.path === "/esg/energy"){
                if(!farmData.kepco){
                  continue;
                }
              }

              this.farmItems.push({
                company_cd: res.data[i].company.code,
                company_name: res.data[i].company.name,
                code: farmData.code,
                name: farmData.name,
                biz: farmData.biz,
                no: farmData.no,
                kepco: farmData.kepco,
              });
            }  

          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboFarms API 호출 오류",err)
        }
      ) 
    },
    fromFarm() {
      this.$emit('fromFarm', {
        farm: this.farm,
        company: this.company,
      });
      let cookie_info = { farm: this.farm, company: this.company};
      VueCookies.set("farm_info" ,cookie_info,"30d");
      let kind = (this.farm.biz == "CF06") ? true : false; 
      this.$store.commit("showMilk",kind);
      
      let hide = (this.farm.biz == "CF05" || this.farm.biz == "CF06") ? false : true;
      // console.log(hide)
      this.$store.commit("hideGrow",hide);
    }
  }
}
</script>

<style>
/* @import '.././style/base.scss'; */
.combo_box{
  width:270px;
  display:flex;
  align-items:center;
}
.farm{
  width:230px !important;
}
.farm .v-input__slot{
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3); /* 그림자 효과 */
}
</style>